export default __webpack_public_path__ + "static/media/land-4.06bbc480.mp4";